import { Union, Record } from "./fable_modules/fable-library.4.10.0/Types.js";
import { getRecordField, getUnionFields, isUnion, obj_type, getRecordElements, name as name_2, option_type, union_type, bool_type, unit_type, anonRecord_type, list_type, string_type, class_type, record_type, int32_type } from "./fable_modules/fable-library.4.10.0/Reflection.js";
import { SlipAnswer__IsOpen, SlipAnswer__SetText, SlipAnswer__SetCorrectness, SlipAnswer__DeleteChoice_Z524259A4, SlipAnswer__AppendChoice, SlipAnswer, SlipAnswer__ToChoice, SlipAnswer__ToOpen, SingleSlip__SetQwText, Question as Question_1, Slip__RemoveFromMultiple_Z524259A4, Slip__get_LastQwIdx, Slip__AppendToMultiple_73903553, Slip__SetMultipleName_Z721C83C5, MainModels_PackageCard__DelSlip_Z524259A4, MainModels_PackageCard__GetNextSlipCaption, SingleSlip_InitEmpty, MainModels_PackageCard__AppendSlip_Z29327777, MainModels_PackageCard, Slip_$reflection, MediaCategory, SingleSlip, MediaDsc, MediaType, Slip, MainModels_PackageCard__UpdateSlip, MainModels_PackageCard__GetSlip_Z524259A4, QwKey, MainModels_ExpertRecord_$reflection, QwKey_$reflection, MainModels_PackageCard_$reflection, RESP$1_$reflection, PackageRecord_$reflection } from "../shared/Shared.fs.js";
import { fileOnChangeAsText, taggedMsg, DeleteForm as DeleteForm_1, mediaTypeFromMiME, ofInt, ofDecimal, download, DeleteForm_Toggle_Z5CE7ED6, uploadFileToS3Cmd, apiCmd, noCmd, DeleteForm_$reflection, TRESP$2_$reflection } from "./Common.fs.js";
import { empty as empty_1, FSharpMap__Remove, FSharpMap__Add } from "./fable_modules/fable-library.4.10.0/Map.js";
import { newGuid } from "./fable_modules/fable-library.4.10.0/Guid.js";
import { printf, toText, substring, isNullOrWhiteSpace } from "./fable_modules/fable-library.4.10.0/String.js";
import { indexed, isEmpty, ofArray, sortBy, reverse, empty, cons, mapIndexed, singleton, filter } from "./fable_modules/fable-library.4.10.0/List.js";
import { value as value_4, bind, defaultArg, defaultArgWith } from "./fable_modules/fable-library.4.10.0/Option.js";
import { FSharpResult$2 } from "./fable_modules/fable-library.4.10.0/Choice.js";
import { SimpleJson_tryParse } from "./fable_modules/Fable.SimpleJson.3.24.0/./SimpleJson.fs.js";
import { Convert_serialize, Convert_fromJson } from "./fable_modules/Fable.SimpleJson.3.24.0/./Json.Converter.fs.js";
import { createTypeInfo } from "./fable_modules/Fable.SimpleJson.3.24.0/./TypeInfo.Converter.fs.js";
import { int32ToString, comparePrimitives } from "./fable_modules/fable-library.4.10.0/Util.js";
import { toString, parse } from "./fable_modules/fable-library.4.10.0/Decimal.js";
import { parse as parse_1 } from "./fable_modules/fable-library.4.10.0/Int32.js";
import { tryFind } from "./fable_modules/fable-library.4.10.0/Array.js";
import * as react from "react";
import { map, collect, empty as empty_2, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library.4.10.0/Seq.js";
import { mediaArea, deleteForm as deleteForm_1, errors } from "./MainTemplates.fs.js";
import { keyValueList } from "./fable_modules/fable-library.4.10.0/MapUtil.js";
import { Helpers_classList } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { HTMLAttr, DOMAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Internal_updateInputValue } from "./fable_modules/Fable.Elmish.React.5.0.0/./common.fs.js";
import { Fa_i, Fa_IconOption, Fa_ISize, Fa_span } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";

export class PkgQwKey extends Record {
    constructor(PackageId, TourIdx, QwIdx) {
        super();
        this.PackageId = (PackageId | 0);
        this.TourIdx = (TourIdx | 0);
        this.QwIdx = (QwIdx | 0);
    }
}

export function PkgQwKey_$reflection() {
    return record_type("MainProdQuestions.PkgQwKey", [], PkgQwKey, () => [["PackageId", int32_type], ["TourIdx", int32_type], ["QwIdx", int32_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Exn", "CreatePackage", "DeleteError", "GetPackagesResp", "ToggleCard", "GetPackageResp", "CreatePackageResp", "UpdateName", "UpdateTransferToken", "ImportCard", "ExportCard", "CancelCard", "SubmitCard", "SubmitCardResp", "AppendSingleSlip", "AppendMultipleSlip", "AppendQwToMultiple", "DelSlip", "DelQwInMultiple", "UpdateTourName", "QwTextChanged", "QwTextSplitChanged", "QwAnswerChanged", "QwCommentChanged", "QwPointsChanged", "QwJpdPointsChanged", "QwWithChoiceChanged", "QwSecondsChanged", "QwEOTChanged", "QwCaptionChanged", "QwMediaChanged", "QwMediaClear", "QwMediaUploaded", "QwMediaUrlChanged", "QwMediaTypeChanged", "AnswerMediaChanged", "AnswerMediaClear", "AnswerMediaUploaded", "AnswerMediaUrlChanged", "AnswerMediaTypeChanged", "ToggleAquireForm", "AquireFormUpdatePackageId", "AquireFormUpdateTransferToken", "AquireFormSend", "AquireFormCancel", "AquirePackageResp", "ToggleDeleteForm", "DeleteFormUpdateText", "DeletePackage", "DeletePackageResp", "ToggleShareForm", "ShareFormUpdateUserId", "ShareFormSend", "ShareRemove", "SharePackageResp", "RemoveShareResp", "ToChoiceAnswer", "ToOpenAnswer", "SetCorrectness", "DeleteChoice", "AppendChoice", "SetChoiceText"];
    }
}

export function Msg_$reflection() {
    return union_type("MainProdQuestions.Msg", [], Msg, () => [[["Item", class_type("System.Exception")]], [], [["Item", string_type]], [["Item", RESP$1_$reflection(list_type(PackageRecord_$reflection()))]], [["Item", int32_type]], [["Item", RESP$1_$reflection(MainModels_PackageCard_$reflection())]], [["Item", RESP$1_$reflection(anonRecord_type(["Card", MainModels_PackageCard_$reflection()], ["Record", PackageRecord_$reflection()]))]], [["Item", string_type]], [["Item", string_type]], [["Item", anonRecord_type(["Body", string_type], ["Name", string_type], ["Tag", unit_type])]], [], [], [], [["Item", RESP$1_$reflection(PackageRecord_$reflection())]], [["qwCount", int32_type]], [], [["Item", int32_type]], [["slipIdx", int32_type]], [["key", QwKey_$reflection()]], [["tourIdx", int32_type], ["txt", string_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["key", QwKey_$reflection()], ["part", int32_type], ["txt", string_type]], [["key", QwKey_$reflection()], ["Item2", string_type]], [["key", QwKey_$reflection()], ["Item2", string_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["key", QwKey_$reflection()], ["Item2", bool_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["key", QwKey_$reflection()], ["Item2", bool_type]], [["key", QwKey_$reflection()], ["txt", string_type]], [["Item", anonRecord_type(["File", class_type("Browser.Types.File", void 0)], ["Tag", PkgQwKey_$reflection()])]], [["key", QwKey_$reflection()]], [["key", QwKey_$reflection()], ["bucketKey", string_type], ["mediType", string_type]], [["key", QwKey_$reflection()], ["url", string_type]], [["key", QwKey_$reflection()], ["typ", string_type]], [["Item", anonRecord_type(["File", class_type("Browser.Types.File", void 0)], ["Tag", PkgQwKey_$reflection()])]], [["key", QwKey_$reflection()]], [["key", QwKey_$reflection()], ["bucketKey", string_type], ["mediType", string_type]], [["key", QwKey_$reflection()], ["url", string_type]], [["key", QwKey_$reflection()], ["typ", string_type]], [], [["Item", string_type]], [["Item", string_type]], [], [], [["Item", RESP$1_$reflection(PackageRecord_$reflection())]], [], [["Item", string_type]], [["Item", int32_type]], [["Item", TRESP$2_$reflection(int32_type, unit_type)]], [], [["Item", string_type]], [["Item", int32_type]], [["Item1", int32_type], ["Item2", string_type]], [["Item", RESP$1_$reflection(MainModels_ExpertRecord_$reflection())]], [["Item", TRESP$2_$reflection(string_type, unit_type)]], [["key", QwKey_$reflection()]], [["key", QwKey_$reflection()]], [["key", QwKey_$reflection()], ["idx", int32_type], ["Item3", bool_type]], [["key", QwKey_$reflection()], ["idx", int32_type]], [["key", QwKey_$reflection()]], [["key", QwKey_$reflection()], ["idx", int32_type], ["Item3", string_type]]]);
}

export class AquireForm extends Record {
    constructor(PackageId, TransferToken, IsSending) {
        super();
        this.PackageId = (PackageId | 0);
        this.TransferToken = TransferToken;
        this.IsSending = IsSending;
    }
}

export function AquireForm_$reflection() {
    return record_type("MainProdQuestions.AquireForm", [], AquireForm, () => [["PackageId", int32_type], ["TransferToken", string_type], ["IsSending", bool_type]]);
}

export class ShareForm extends Record {
    constructor(UserId, Error$, IsSending) {
        super();
        this.UserId = UserId;
        this.Error = Error$;
        this.IsSending = IsSending;
    }
}

export function ShareForm_$reflection() {
    return record_type("MainProdQuestions.ShareForm", [], ShareForm, () => [["UserId", string_type], ["Error", string_type], ["IsSending", bool_type]]);
}

export class Model extends Record {
    constructor(Packages, Errors, CardIsLoading, Card, AquiringForm, DeleteForm, ShareForm) {
        super();
        this.Packages = Packages;
        this.Errors = Errors;
        this.CardIsLoading = CardIsLoading;
        this.Card = Card;
        this.AquiringForm = AquiringForm;
        this.DeleteForm = DeleteForm;
        this.ShareForm = ShareForm;
    }
}

export function Model_$reflection() {
    return record_type("MainProdQuestions.Model", [], Model, () => [["Packages", list_type(PackageRecord_$reflection())], ["Errors", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])], ["CardIsLoading", option_type(int32_type)], ["Card", option_type(MainModels_PackageCard_$reflection())], ["AquiringForm", option_type(AquireForm_$reflection())], ["DeleteForm", option_type(DeleteForm_$reflection())], ["ShareForm", option_type(ShareForm_$reflection())]]);
}

export function PkgQwKey__get_Key(x) {
    return new QwKey(x.TourIdx, x.QwIdx);
}

export function PkgQwKey__IdxOfQw_Z524259A4(x, idx) {
    return [x.TourIdx, idx];
}

export function addError(txt, model) {
    let copyOfStruct;
    return new Model(model.Packages, FSharpMap__Add(model.Errors, (copyOfStruct = newGuid(), copyOfStruct), txt), model.CardIsLoading, model.Card, model.AquiringForm, model.DeleteForm, model.ShareForm);
}

export function delError(id, model) {
    return new Model(model.Packages, FSharpMap__Remove(model.Errors, id), model.CardIsLoading, model.Card, model.AquiringForm, model.DeleteForm, model.ShareForm);
}

export function loading(pkgId, model) {
    return new Model(model.Packages, model.Errors, pkgId, model.Card, model.AquiringForm, model.DeleteForm, model.ShareForm);
}

export function toggleCard(api, packageId, model) {
    if (model.CardIsLoading == null) {
        const matchValue_1 = model.Card;
        let matchResult, card_2;
        if (matchValue_1 != null) {
            if (matchValue_1.PackageId === packageId) {
                matchResult = 0;
                card_2 = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return noCmd(new Model(model.Packages, model.Errors, model.CardIsLoading, void 0, model.AquiringForm, model.DeleteForm, void 0));
            default:
                return apiCmd(api.getProdPackageCard, {
                    PackageId: packageId,
                }, (Item) => (new Msg(5, [Item])), (Item_1) => (new Msg(0, [Item_1])), loading(packageId, new Model(model.Packages, model.Errors, model.CardIsLoading, void 0, model.AquiringForm, model.DeleteForm, void 0)));
        }
    }
    else {
        return noCmd(model);
    }
}

export function editing(model) {
    return new Model(model.Packages, model.Errors, void 0, model.Card, model.AquiringForm, model.DeleteForm, model.ShareForm);
}

export function validateName(txt) {
    if (isNullOrWhiteSpace(txt)) {
        return "Name is required";
    }
    else {
        return "";
    }
}

export function validate(card_1) {
    return filter((s) => (s !== ""), singleton(validateName(card_1.Name)));
}

export function updateCard(f, model) {
    const matchValue = model.Card;
    if (matchValue != null) {
        return new Model(model.Packages, model.Errors, model.CardIsLoading, f(matchValue), model.AquiringForm, model.DeleteForm, model.ShareForm);
    }
    else {
        return model;
    }
}

export function updateSlip(qwKey, f, model) {
    return updateCard((card_1) => {
        let tupledArg;
        const matchValue = MainModels_PackageCard__GetSlip_Z524259A4(card_1, qwKey.TourIdx);
        if (matchValue == null) {
            return card_1;
        }
        else if (matchValue.tag === 1) {
            const name = matchValue.fields[0];
            const slips = matchValue.fields[1];
            return MainModels_PackageCard__UpdateSlip(card_1, qwKey.TourIdx, (tupledArg = [name, mapIndexed((idx_1, slip_2) => {
                if (idx_1 === qwKey.QwIdx) {
                    return f(slip_2);
                }
                else {
                    return slip_2;
                }
            }, slips)], new Slip(1, [tupledArg[0], tupledArg[1]])));
        }
        else {
            const slip = matchValue.fields[0];
            return MainModels_PackageCard__UpdateSlip(card_1, qwKey.TourIdx, new Slip(0, [f(slip)]));
        }
    }, model);
}

export function updateQuestionMedia(qwKey, f, model) {
    return updateSlip(qwKey, (slip) => (new SingleSlip(slip.Caption, slip.Question, f(defaultArgWith(slip.QuestionMedia, () => (new MediaDsc("", new MediaType(0, []))))), slip.Answer, slip.AnswerMedia, slip.Comment, slip.Points, slip.JeopardyPoints, slip.WithChoice, slip.Seconds, slip.EndOfTour)), model);
}

export function updateAnswerMedia(qwKey, f, model) {
    return updateSlip(qwKey, (slip) => (new SingleSlip(slip.Caption, slip.Question, slip.QuestionMedia, slip.Answer, f(defaultArgWith(slip.AnswerMedia, () => (new MediaDsc("", new MediaType(0, []))))), slip.Comment, slip.Points, slip.JeopardyPoints, slip.WithChoice, slip.Seconds, slip.EndOfTour)), model);
}

export function submitCard(api, model) {
    const matchValue = model.Card;
    if (matchValue == null) {
        return noCmd(model);
    }
    else {
        const card_1 = matchValue;
        return apiCmd(api.updateProdPackageCard, card_1, (Item) => (new Msg(13, [Item])), (Item_1) => (new Msg(0, [Item_1])), loading(card_1.PackageId, model));
    }
}

export function replaceRecord(record, model) {
    return new Model(cons(record, filter((q) => (q.PackageId !== record.PackageId), model.Packages)), model.Errors, model.CardIsLoading, model.Card, model.AquiringForm, model.DeleteForm, model.ShareForm);
}

export function uploadFile(api, tag, file, msg, model) {
    if (file.size > ((1024 * 1024) * 8)) {
        return noCmd(addError("max allowed size is 8Mb", model));
    }
    else {
        return [loading(tag.PackageId, model), uploadFileToS3Cmd(api.getUploadUrl, new MediaCategory(1, []), file, msg, (Item) => (new Msg(0, [Item])))];
    }
}

export function toggleAquiringForm(model) {
    return new Model(model.Packages, model.Errors, model.CardIsLoading, model.Card, (model.AquiringForm == null) ? (new AquireForm(0, "", false)) : void 0, model.DeleteForm, model.ShareForm);
}

export function updateAquiringForm(f, model) {
    const matchValue = model.AquiringForm;
    if (matchValue == null) {
        return model;
    }
    else {
        return new Model(model.Packages, model.Errors, model.CardIsLoading, model.Card, f(matchValue), model.DeleteForm, model.ShareForm);
    }
}

export function sendAquiringForm(api, model) {
    let form;
    const matchValue = model.AquiringForm;
    let matchResult, form_1;
    if (matchValue != null) {
        if ((form = matchValue, (form.PackageId > 0) && !isNullOrWhiteSpace(form.TransferToken))) {
            matchResult = 0;
            form_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const model_2 = updateAquiringForm((form_2) => (new AquireForm(form_2.PackageId, form_2.TransferToken, true)), model);
            return apiCmd(api.aquirePackage, {
                PackageId: form_1.PackageId,
                TransferToken: form_1.TransferToken.trim(),
            }, (Item) => (new Msg(45, [Item])), (Item_1) => (new Msg(0, [Item_1])), model_2);
        }
        default:
            return noCmd(model);
    }
}

export function toggleDeleteForm(model) {
    return new Model(model.Packages, model.Errors, model.CardIsLoading, model.Card, model.AquiringForm, DeleteForm_Toggle_Z5CE7ED6(model.DeleteForm), model.ShareForm);
}

export function updateDeleteForm(f, model) {
    const matchValue = model.DeleteForm;
    if (matchValue == null) {
        return model;
    }
    else {
        return new Model(model.Packages, model.Errors, model.CardIsLoading, model.Card, model.AquiringForm, f(matchValue), model.ShareForm);
    }
}

export function afterPackageDeletion(packageId, model) {
    return new Model(filter((p) => (p.PackageId !== packageId), model.Packages), model.Errors, model.CardIsLoading, void 0, model.AquiringForm, void 0, void 0);
}

export function updateShareForm(f, model) {
    const matchValue = model.ShareForm;
    if (matchValue == null) {
        return model;
    }
    else {
        return new Model(model.Packages, model.Errors, model.CardIsLoading, model.Card, model.AquiringForm, model.DeleteForm, f(matchValue));
    }
}

export function importFromJson(name, json, model) {
    let matchValue;
    const dotIdx = name.lastIndexOf(".") | 0;
    const name_1 = (dotIdx > 0) ? substring(name, 0, dotIdx) : name;
    let matchValue_1;
    try {
        matchValue_1 = (new FSharpResult$2(0, [(matchValue = SimpleJson_tryParse(json), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(list_type(Slip_$reflection()))) : (() => {
            throw new Error("Couldn\'t parse the input JSON string because it seems to be invalid");
        })())]));
    }
    catch (ex) {
        matchValue_1 = (new FSharpResult$2(1, [ex.message]));
    }
    if (matchValue_1.tag === 1) {
        return noCmd(editing(addError(matchValue_1.fields[0], model)));
    }
    else {
        return noCmd(editing(updateCard((c) => (new MainModels_PackageCard(c.PackageId, c.Producer, name_1, c.TransferToken, c.SharedWith, matchValue_1.fields[0])), model)));
    }
}

export function init(api, user) {
    return apiCmd(api.getProdPackages, void 0, (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(0, [Item_1])), new Model(empty(), empty_1({
        Compare: comparePrimitives,
    }), void 0, void 0, void 0, void 0, void 0));
}

export function update(api, user, msg, cm) {
    let matchResult, id, res_4, quizId, res_5, res_6, txt_4, txt_5, res_7, res_8, qwCount, tourIdx, tourIdx_1, txt_6, tourIdx_2, key, key_1, txt_7, key_2, part, txt_8, key_3, key_4, key_5, txt_10, key_6, idx_4, key_7, idx_5, isCorrect, key_8, idx_7, key_9, txt_11, key_10, txt_13, key_11, txt_14, key_12, txt_15, key_13, txt_16, key_14, v, key_15, v_1, key_16, v_2, res_9, key_18, bucketKey, mediaType, qwKey, key_19, url, key_20, typ, res_10, key_22, bucketKey_1, mediaType_1, qwKey_1, key_23, url_1, key_24, typ_1, txt_17, txt_18, record, txt_19, txt_20, packageId, quizId_1, txt_21, txt_22, pkgId, pkgId_1, userId, txt_23, res_11, userId_1, txt_24, ex, txt_26;
    switch (msg.tag) {
        case 3: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 1;
                res_4 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult;
                const msg_1 = msg;
                const pi_1 = tryFind((pi) => (name_2(pi) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1 == null) {
                    activePatternResult = void 0;
                }
                else {
                    const pi$0027 = pi_1;
                    let msgType;
                    let copyOfStruct = msg_1;
                    msgType = Msg_$reflection();
                    if (isUnion(msgType)) {
                        const objArray = getUnionFields(msg_1, msgType)[1];
                        if (objArray.length === 1) {
                            try {
                                const patternInput_1 = getUnionFields(getRecordField(objArray[0], pi$0027), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult = ((name_2(patternInput_1[0]) === "Error") ? patternInput_1[1][0] : void 0);
                            }
                            catch (matchValue) {
                                activePatternResult = void 0;
                            }
                        }
                        else {
                            activePatternResult = void 0;
                        }
                    }
                    else {
                        activePatternResult = void 0;
                    }
                }
                if (activePatternResult != null) {
                    matchResult = 66;
                    txt_26 = activePatternResult;
                }
                else {
                    matchResult = 67;
                }
            }
            break;
        }
        case 4: {
            matchResult = 2;
            quizId = msg.fields[0];
            break;
        }
        case 5: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 3;
                res_5 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_1;
                const msg_2 = msg;
                const pi_1_1 = tryFind((pi_2) => (name_2(pi_2) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_1 == null) {
                    activePatternResult_1 = void 0;
                }
                else {
                    const pi$0027_1 = pi_1_1;
                    let msgType_1;
                    let copyOfStruct_1 = msg_2;
                    msgType_1 = Msg_$reflection();
                    if (isUnion(msgType_1)) {
                        const objArray_2 = getUnionFields(msg_2, msgType_1)[1];
                        if (objArray_2.length === 1) {
                            try {
                                const patternInput_1_1 = getUnionFields(getRecordField(objArray_2[0], pi$0027_1), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_1 = ((name_2(patternInput_1_1[0]) === "Error") ? patternInput_1_1[1][0] : void 0);
                            }
                            catch (matchValue_1) {
                                activePatternResult_1 = void 0;
                            }
                        }
                        else {
                            activePatternResult_1 = void 0;
                        }
                    }
                    else {
                        activePatternResult_1 = void 0;
                    }
                }
                if (activePatternResult_1 != null) {
                    matchResult = 66;
                    txt_26 = activePatternResult_1;
                }
                else {
                    matchResult = 67;
                }
            }
            break;
        }
        case 1: {
            matchResult = 4;
            break;
        }
        case 6: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 5;
                res_6 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_2;
                const msg_3 = msg;
                const pi_1_2 = tryFind((pi_3) => (name_2(pi_3) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_2 == null) {
                    activePatternResult_2 = void 0;
                }
                else {
                    const pi$0027_2 = pi_1_2;
                    let msgType_2;
                    let copyOfStruct_2 = msg_3;
                    msgType_2 = Msg_$reflection();
                    if (isUnion(msgType_2)) {
                        const objArray_3 = getUnionFields(msg_3, msgType_2)[1];
                        if (objArray_3.length === 1) {
                            try {
                                const patternInput_1_2 = getUnionFields(getRecordField(objArray_3[0], pi$0027_2), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_2 = ((name_2(patternInput_1_2[0]) === "Error") ? patternInput_1_2[1][0] : void 0);
                            }
                            catch (matchValue_2) {
                                activePatternResult_2 = void 0;
                            }
                        }
                        else {
                            activePatternResult_2 = void 0;
                        }
                    }
                    else {
                        activePatternResult_2 = void 0;
                    }
                }
                if (activePatternResult_2 != null) {
                    matchResult = 66;
                    txt_26 = activePatternResult_2;
                }
                else {
                    matchResult = 67;
                }
            }
            break;
        }
        case 7: {
            matchResult = 6;
            txt_4 = msg.fields[0];
            break;
        }
        case 8: {
            matchResult = 7;
            txt_5 = msg.fields[0];
            break;
        }
        case 10: {
            matchResult = 8;
            break;
        }
        case 9: {
            matchResult = 9;
            res_7 = msg.fields[0];
            break;
        }
        case 11: {
            matchResult = 10;
            break;
        }
        case 12: {
            matchResult = 11;
            break;
        }
        case 13: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 12;
                res_8 = msg.fields[0].Value.fields[0];
            }
            else {
                let activePatternResult_3;
                const msg_4 = msg;
                const pi_1_3 = tryFind((pi_4) => (name_2(pi_4) === "Value"), getRecordElements(RESP$1_$reflection(obj_type)));
                if (pi_1_3 == null) {
                    activePatternResult_3 = void 0;
                }
                else {
                    const pi$0027_3 = pi_1_3;
                    let msgType_3;
                    let copyOfStruct_3 = msg_4;
                    msgType_3 = Msg_$reflection();
                    if (isUnion(msgType_3)) {
                        const objArray_4 = getUnionFields(msg_4, msgType_3)[1];
                        if (objArray_4.length === 1) {
                            try {
                                const patternInput_1_3 = getUnionFields(getRecordField(objArray_4[0], pi$0027_3), union_type("Microsoft.FSharp.Core.FSharpResult`2", [obj_type, obj_type], FSharpResult$2, () => [[["ResultValue", obj_type]], [["ErrorValue", obj_type]]]));
                                activePatternResult_3 = ((name_2(patternInput_1_3[0]) === "Error") ? patternInput_1_3[1][0] : void 0);
                            }
                            catch (matchValue_3) {
                                activePatternResult_3 = void 0;
                            }
                        }
                        else {
                            activePatternResult_3 = void 0;
                        }
                    }
                    else {
                        activePatternResult_3 = void 0;
                    }
                }
                if (activePatternResult_3 != null) {
                    matchResult = 66;
                    txt_26 = activePatternResult_3;
                }
                else {
                    matchResult = 67;
                }
            }
            break;
        }
        case 14: {
            matchResult = 13;
            qwCount = msg.fields[0];
            break;
        }
        case 15: {
            matchResult = 14;
            break;
        }
        case 17: {
            matchResult = 15;
            tourIdx = msg.fields[0];
            break;
        }
        case 19: {
            matchResult = 16;
            tourIdx_1 = msg.fields[0];
            txt_6 = msg.fields[1];
            break;
        }
        case 16: {
            matchResult = 17;
            tourIdx_2 = msg.fields[0];
            break;
        }
        case 18: {
            matchResult = 18;
            key = msg.fields[0];
            break;
        }
        case 20: {
            matchResult = 19;
            key_1 = msg.fields[0];
            txt_7 = msg.fields[1];
            break;
        }
        case 21: {
            matchResult = 20;
            key_2 = msg.fields[0];
            part = msg.fields[1];
            txt_8 = msg.fields[2];
            break;
        }
        case 57: {
            matchResult = 21;
            key_3 = msg.fields[0];
            break;
        }
        case 56: {
            matchResult = 22;
            key_4 = msg.fields[0];
            break;
        }
        case 22: {
            matchResult = 23;
            key_5 = msg.fields[0];
            txt_10 = msg.fields[1];
            break;
        }
        case 60: {
            matchResult = 24;
            key_6 = msg.fields[0];
            break;
        }
        case 59: {
            matchResult = 25;
            idx_4 = msg.fields[1];
            key_7 = msg.fields[0];
            break;
        }
        case 58: {
            matchResult = 26;
            idx_5 = msg.fields[1];
            isCorrect = msg.fields[2];
            key_8 = msg.fields[0];
            break;
        }
        case 61: {
            matchResult = 27;
            idx_7 = msg.fields[1];
            key_9 = msg.fields[0];
            txt_11 = msg.fields[2];
            break;
        }
        case 23: {
            matchResult = 28;
            key_10 = msg.fields[0];
            txt_13 = msg.fields[1];
            break;
        }
        case 24: {
            matchResult = 29;
            key_11 = msg.fields[0];
            txt_14 = msg.fields[1];
            break;
        }
        case 25: {
            matchResult = 30;
            key_12 = msg.fields[0];
            txt_15 = msg.fields[1];
            break;
        }
        case 27: {
            matchResult = 31;
            key_13 = msg.fields[0];
            txt_16 = msg.fields[1];
            break;
        }
        case 26: {
            matchResult = 32;
            key_14 = msg.fields[0];
            v = msg.fields[1];
            break;
        }
        case 28: {
            matchResult = 33;
            key_15 = msg.fields[0];
            v_1 = msg.fields[1];
            break;
        }
        case 29: {
            matchResult = 34;
            key_16 = msg.fields[0];
            v_2 = msg.fields[1];
            break;
        }
        case 30: {
            matchResult = 35;
            res_9 = msg.fields[0];
            break;
        }
        case 31: {
            matchResult = 36;
            key_18 = msg.fields[0];
            break;
        }
        case 32: {
            matchResult = 37;
            bucketKey = msg.fields[1];
            mediaType = msg.fields[2];
            qwKey = msg.fields[0];
            break;
        }
        case 33: {
            matchResult = 38;
            key_19 = msg.fields[0];
            url = msg.fields[1];
            break;
        }
        case 34: {
            matchResult = 39;
            key_20 = msg.fields[0];
            typ = msg.fields[1];
            break;
        }
        case 35: {
            matchResult = 40;
            res_10 = msg.fields[0];
            break;
        }
        case 36: {
            matchResult = 41;
            key_22 = msg.fields[0];
            break;
        }
        case 37: {
            matchResult = 42;
            bucketKey_1 = msg.fields[1];
            mediaType_1 = msg.fields[2];
            qwKey_1 = msg.fields[0];
            break;
        }
        case 38: {
            matchResult = 43;
            key_23 = msg.fields[0];
            url_1 = msg.fields[1];
            break;
        }
        case 39: {
            matchResult = 44;
            key_24 = msg.fields[0];
            typ_1 = msg.fields[1];
            break;
        }
        case 40: {
            matchResult = 45;
            break;
        }
        case 41: {
            matchResult = 46;
            txt_17 = msg.fields[0];
            break;
        }
        case 42: {
            matchResult = 47;
            txt_18 = msg.fields[0];
            break;
        }
        case 44: {
            matchResult = 48;
            break;
        }
        case 43: {
            matchResult = 49;
            break;
        }
        case 45: {
            if (msg.fields[0].Value.tag === 1) {
                matchResult = 51;
                txt_19 = msg.fields[0].Value.fields[0];
            }
            else {
                matchResult = 50;
                record = msg.fields[0].Value.fields[0];
            }
            break;
        }
        case 46: {
            matchResult = 52;
            break;
        }
        case 47: {
            matchResult = 53;
            txt_20 = msg.fields[0];
            break;
        }
        case 48: {
            matchResult = 54;
            packageId = msg.fields[0];
            break;
        }
        case 49: {
            if (msg.fields[0].Rsp.Value.tag === 1) {
                matchResult = 56;
                txt_21 = msg.fields[0].Rsp.Value.fields[0];
            }
            else {
                matchResult = 55;
                quizId_1 = msg.fields[0].Tag;
            }
            break;
        }
        case 50: {
            matchResult = 57;
            break;
        }
        case 51: {
            matchResult = 58;
            txt_22 = msg.fields[0];
            break;
        }
        case 52: {
            matchResult = 59;
            pkgId = msg.fields[0];
            break;
        }
        case 53: {
            matchResult = 60;
            pkgId_1 = msg.fields[0];
            userId = msg.fields[1];
            break;
        }
        case 54: {
            if (msg.fields[0].Value.tag === 0) {
                matchResult = 62;
                res_11 = msg.fields[0].Value.fields[0];
            }
            else {
                matchResult = 61;
                txt_23 = msg.fields[0].Value.fields[0];
            }
            break;
        }
        case 55: {
            if (msg.fields[0].Rsp.Value.tag === 1) {
                matchResult = 64;
                txt_24 = msg.fields[0].Rsp.Value.fields[0];
            }
            else {
                matchResult = 63;
                userId_1 = msg.fields[0].Tag;
            }
            break;
        }
        case 0: {
            matchResult = 65;
            ex = msg.fields[0];
            break;
        }
        default: {
            matchResult = 0;
            id = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return noCmd(delError(id, cm));
        case 1:
            return noCmd(new Model(res_4, cm.Errors, cm.CardIsLoading, cm.Card, cm.AquiringForm, cm.DeleteForm, cm.ShareForm));
        case 2:
            return toggleCard(api, quizId, cm);
        case 3:
            return noCmd(editing(new Model(cm.Packages, cm.Errors, cm.CardIsLoading, res_5, cm.AquiringForm, cm.DeleteForm, cm.ShareForm)));
        case 4:
            return apiCmd(api.createPackage, void 0, (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(0, [Item_1])), cm);
        case 5:
            return noCmd(new Model(cons(res_6.Record, cm.Packages), cm.Errors, cm.CardIsLoading, res_6.Card, cm.AquiringForm, cm.DeleteForm, cm.ShareForm));
        case 6:
            return noCmd(updateCard((c) => (new MainModels_PackageCard(c.PackageId, c.Producer, txt_4, c.TransferToken, c.SharedWith, c.Slips)), cm));
        case 7:
            return noCmd(updateCard((c_1) => (new MainModels_PackageCard(c_1.PackageId, c_1.Producer, c_1.Name, txt_5, c_1.SharedWith, c_1.Slips)), cm));
        case 8: {
            const matchValue_4 = cm.Card;
            if (matchValue_4 == null) {
                return noCmd(cm);
            }
            else {
                const card_1 = matchValue_4;
                download(card_1.Name, "application/json", Convert_serialize(card_1.Slips, createTypeInfo(list_type(Slip_$reflection()))));
                return noCmd(cm);
            }
        }
        case 9:
            return importFromJson(res_7.Name, res_7.Body, cm);
        case 10:
            return noCmd(new Model(cm.Packages, cm.Errors, cm.CardIsLoading, void 0, cm.AquiringForm, cm.DeleteForm, void 0));
        case 11:
            return submitCard(api, cm);
        case 12:
            return noCmd(replaceRecord(res_8, editing(new Model(cm.Packages, cm.Errors, cm.CardIsLoading, void 0, cm.AquiringForm, cm.DeleteForm, void 0))));
        case 13:
            return noCmd(updateCard((c_2) => MainModels_PackageCard__AppendSlip_Z29327777(c_2, new Slip(0, [SingleSlip_InitEmpty(MainModels_PackageCard__GetNextSlipCaption(c_2), qwCount)])), cm));
        case 14:
            return noCmd(updateCard((c_3) => {
                let tupledArg;
                return MainModels_PackageCard__AppendSlip_Z29327777(c_3, (tupledArg = ["", empty()], new Slip(1, [tupledArg[0], tupledArg[1]])));
            }, cm));
        case 15:
            return noCmd(updateCard((c_4) => MainModels_PackageCard__DelSlip_Z524259A4(c_4, tourIdx), cm));
        case 16:
            return noCmd(updateCard((c_5) => defaultArg(bind((slip) => MainModels_PackageCard__UpdateSlip(c_5, tourIdx_1, Slip__SetMultipleName_Z721C83C5(slip, txt_6)), MainModels_PackageCard__GetSlip_Z524259A4(c_5, tourIdx_1)), c_5), cm));
        case 17:
            return noCmd(updateCard((c_6) => defaultArg(bind((slip_2) => {
                let arg, arg_1;
                return MainModels_PackageCard__UpdateSlip(c_6, tourIdx_2, Slip__AppendToMultiple_73903553(slip_2, SingleSlip_InitEmpty((arg = ((tourIdx_2 + 1) | 0), (arg_1 = ((Slip__get_LastQwIdx(slip_2) + 2) | 0), toText(printf("%i.%i"))(arg)(arg_1))), 1)));
            }, MainModels_PackageCard__GetSlip_Z524259A4(c_6, tourIdx_2)), c_6), cm));
        case 18:
            return noCmd(updateCard((c_7) => defaultArg(bind((slip_5) => MainModels_PackageCard__UpdateSlip(c_7, key.TourIdx, Slip__RemoveFromMultiple_Z524259A4(slip_5, key.QwIdx)), MainModels_PackageCard__GetSlip_Z524259A4(c_7, key.TourIdx)), c_7), cm));
        case 19:
            return noCmd(updateSlip(key_1, (slip_7) => (new SingleSlip(slip_7.Caption, new Question_1(0, [txt_7]), slip_7.QuestionMedia, slip_7.Answer, slip_7.AnswerMedia, slip_7.Comment, slip_7.Points, slip_7.JeopardyPoints, slip_7.WithChoice, slip_7.Seconds, slip_7.EndOfTour)), cm));
        case 20:
            return noCmd(updateSlip(key_2, (slip_8) => SingleSlip__SetQwText(slip_8, part, txt_8), cm));
        case 21:
            return noCmd(updateSlip(key_3, (slip_9) => (new SingleSlip(slip_9.Caption, slip_9.Question, slip_9.QuestionMedia, SlipAnswer__ToOpen(slip_9.Answer), slip_9.AnswerMedia, slip_9.Comment, slip_9.Points, slip_9.JeopardyPoints, slip_9.WithChoice, slip_9.Seconds, slip_9.EndOfTour)), cm));
        case 22:
            return noCmd(updateSlip(key_4, (slip_10) => (new SingleSlip(slip_10.Caption, slip_10.Question, slip_10.QuestionMedia, SlipAnswer__ToChoice(slip_10.Answer), slip_10.AnswerMedia, slip_10.Comment, slip_10.Points, slip_10.JeopardyPoints, slip_10.WithChoice, slip_10.Seconds, slip_10.EndOfTour)), cm));
        case 23:
            return noCmd(updateSlip(key_5, (slip_11) => (new SingleSlip(slip_11.Caption, slip_11.Question, slip_11.QuestionMedia, new SlipAnswer(0, [txt_10]), slip_11.AnswerMedia, slip_11.Comment, slip_11.Points, slip_11.JeopardyPoints, slip_11.WithChoice, slip_11.Seconds, slip_11.EndOfTour)), cm));
        case 24:
            return noCmd(updateSlip(key_6, (slip_12) => (new SingleSlip(slip_12.Caption, slip_12.Question, slip_12.QuestionMedia, SlipAnswer__AppendChoice(slip_12.Answer), slip_12.AnswerMedia, slip_12.Comment, slip_12.Points, slip_12.JeopardyPoints, slip_12.WithChoice, slip_12.Seconds, slip_12.EndOfTour)), cm));
        case 25:
            return noCmd(updateSlip(key_7, (slip_13) => (new SingleSlip(slip_13.Caption, slip_13.Question, slip_13.QuestionMedia, SlipAnswer__DeleteChoice_Z524259A4(slip_13.Answer, idx_4), slip_13.AnswerMedia, slip_13.Comment, slip_13.Points, slip_13.JeopardyPoints, slip_13.WithChoice, slip_13.Seconds, slip_13.EndOfTour)), cm));
        case 26:
            return noCmd(updateSlip(key_8, (slip_14) => (new SingleSlip(slip_14.Caption, slip_14.Question, slip_14.QuestionMedia, SlipAnswer__SetCorrectness(slip_14.Answer, idx_5, isCorrect), slip_14.AnswerMedia, slip_14.Comment, slip_14.Points, slip_14.JeopardyPoints, slip_14.WithChoice, slip_14.Seconds, slip_14.EndOfTour)), cm));
        case 27:
            return noCmd(updateSlip(key_9, (slip_15) => (new SingleSlip(slip_15.Caption, slip_15.Question, slip_15.QuestionMedia, SlipAnswer__SetText(slip_15.Answer, idx_7, txt_11), slip_15.AnswerMedia, slip_15.Comment, slip_15.Points, slip_15.JeopardyPoints, slip_15.WithChoice, slip_15.Seconds, slip_15.EndOfTour)), cm));
        case 28:
            return noCmd(updateSlip(key_10, (slip_16) => (new SingleSlip(slip_16.Caption, slip_16.Question, slip_16.QuestionMedia, slip_16.Answer, slip_16.AnswerMedia, txt_13, slip_16.Points, slip_16.JeopardyPoints, slip_16.WithChoice, slip_16.Seconds, slip_16.EndOfTour)), cm));
        case 29:
            return noCmd(updateSlip(key_11, (slip_17) => (new SingleSlip(slip_17.Caption, slip_17.Question, slip_17.QuestionMedia, slip_17.Answer, slip_17.AnswerMedia, slip_17.Comment, parse(txt_14), slip_17.JeopardyPoints, slip_17.WithChoice, slip_17.Seconds, slip_17.EndOfTour)), cm));
        case 30:
            return noCmd(updateSlip(key_12, (slip_18) => (new SingleSlip(slip_18.Caption, slip_18.Question, slip_18.QuestionMedia, slip_18.Answer, slip_18.AnswerMedia, slip_18.Comment, slip_18.Points, ofDecimal(txt_15), slip_18.WithChoice, slip_18.Seconds, slip_18.EndOfTour)), cm));
        case 31:
            return noCmd(updateSlip(key_13, (slip_19) => (new SingleSlip(slip_19.Caption, slip_19.Question, slip_19.QuestionMedia, slip_19.Answer, slip_19.AnswerMedia, slip_19.Comment, slip_19.Points, slip_19.JeopardyPoints, slip_19.WithChoice, ofInt(txt_16), slip_19.EndOfTour)), cm));
        case 32:
            return noCmd(updateSlip(key_14, (slip_20) => (new SingleSlip(slip_20.Caption, slip_20.Question, slip_20.QuestionMedia, slip_20.Answer, slip_20.AnswerMedia, slip_20.Comment, slip_20.Points, slip_20.JeopardyPoints, v, slip_20.Seconds, slip_20.EndOfTour)), cm));
        case 33:
            return noCmd(updateSlip(key_15, (slip_21) => (new SingleSlip(slip_21.Caption, slip_21.Question, slip_21.QuestionMedia, slip_21.Answer, slip_21.AnswerMedia, slip_21.Comment, slip_21.Points, slip_21.JeopardyPoints, slip_21.WithChoice, slip_21.Seconds, v_1)), cm));
        case 34:
            return noCmd(updateSlip(key_16, (slip_22) => (new SingleSlip(v_2, slip_22.Question, slip_22.QuestionMedia, slip_22.Answer, slip_22.AnswerMedia, slip_22.Comment, slip_22.Points, slip_22.JeopardyPoints, slip_22.WithChoice, slip_22.Seconds, slip_22.EndOfTour)), cm));
        case 35:
            return uploadFile(api, res_9.Tag, res_9.File, (key_17) => (new Msg(32, [PkgQwKey__get_Key(res_9.Tag), key_17, res_9.File.type])), cm);
        case 36:
            return noCmd(updateSlip(key_18, (slip_23) => (new SingleSlip(slip_23.Caption, slip_23.Question, void 0, slip_23.Answer, slip_23.AnswerMedia, slip_23.Comment, slip_23.Points, slip_23.JeopardyPoints, slip_23.WithChoice, slip_23.Seconds, slip_23.EndOfTour)), cm));
        case 37:
            return noCmd(updateSlip(qwKey, (slip_24) => (new SingleSlip(slip_24.Caption, slip_24.Question, new MediaDsc(bucketKey, mediaTypeFromMiME(mediaType)), slip_24.Answer, slip_24.AnswerMedia, slip_24.Comment, slip_24.Points, slip_24.JeopardyPoints, slip_24.WithChoice, slip_24.Seconds, slip_24.EndOfTour)), editing(cm)));
        case 38:
            return noCmd(updateQuestionMedia(key_19, (media) => (new MediaDsc(url, media.Type)), cm));
        case 39:
            return noCmd(updateQuestionMedia(key_20, (media_1) => (new MediaDsc(media_1.Key, mediaTypeFromMiME(typ))), cm));
        case 40:
            return uploadFile(api, res_10.Tag, res_10.File, (key_21) => (new Msg(37, [PkgQwKey__get_Key(res_10.Tag), key_21, res_10.File.type])), cm);
        case 41:
            return noCmd(updateSlip(key_22, (slip_25) => (new SingleSlip(slip_25.Caption, slip_25.Question, slip_25.QuestionMedia, slip_25.Answer, void 0, slip_25.Comment, slip_25.Points, slip_25.JeopardyPoints, slip_25.WithChoice, slip_25.Seconds, slip_25.EndOfTour)), cm));
        case 42:
            return noCmd(updateSlip(qwKey_1, (slip_26) => (new SingleSlip(slip_26.Caption, slip_26.Question, slip_26.QuestionMedia, slip_26.Answer, new MediaDsc(bucketKey_1, mediaTypeFromMiME(mediaType_1)), slip_26.Comment, slip_26.Points, slip_26.JeopardyPoints, slip_26.WithChoice, slip_26.Seconds, slip_26.EndOfTour)), editing(cm)));
        case 43:
            return noCmd(updateAnswerMedia(key_23, (media_2) => (new MediaDsc(url_1, media_2.Type)), cm));
        case 44:
            return noCmd(updateAnswerMedia(key_24, (media_3) => (new MediaDsc(media_3.Key, mediaTypeFromMiME(typ_1))), cm));
        case 45:
            return noCmd(toggleAquiringForm(cm));
        case 46:
            return noCmd(updateAquiringForm((form) => (new AquireForm(parse_1(txt_17, 511, false, 32), form.TransferToken, form.IsSending)), cm));
        case 47:
            return noCmd(updateAquiringForm((form_1) => (new AquireForm(form_1.PackageId, txt_18.trim(), form_1.IsSending)), cm));
        case 48:
            return noCmd(new Model(cm.Packages, cm.Errors, cm.CardIsLoading, cm.Card, void 0, cm.DeleteForm, cm.ShareForm));
        case 49:
            return sendAquiringForm(api, cm);
        case 50:
            return noCmd(new Model(cons(record, cm.Packages), cm.Errors, cm.CardIsLoading, cm.Card, void 0, cm.DeleteForm, cm.ShareForm));
        case 51:
            return noCmd(updateAquiringForm((form_2) => (new AquireForm(form_2.PackageId, form_2.TransferToken, false)), addError(txt_19, cm)));
        case 52:
            return noCmd(toggleDeleteForm(cm));
        case 53:
            return noCmd(updateDeleteForm((form_3) => (new DeleteForm_1(txt_20, "", form_3.IsSending)), cm));
        case 54:
            return apiCmd(api.deletePackage, {
                PackageId: packageId,
            }, (rsp) => taggedMsg((Item_5) => (new Msg(49, [Item_5])), packageId, rsp), (Item_6) => (new Msg(0, [Item_6])), updateDeleteForm((form_4) => (new DeleteForm_1(form_4.ConfirmText, form_4.FormError, true)), cm));
        case 55:
            return noCmd(afterPackageDeletion(quizId_1, cm));
        case 56:
            return noCmd(updateDeleteForm((form_5) => (new DeleteForm_1(form_5.ConfirmText, txt_21, false)), cm));
        case 57:
            return noCmd(new Model(cm.Packages, cm.Errors, cm.CardIsLoading, cm.Card, cm.AquiringForm, cm.DeleteForm, (cm.ShareForm == null) ? (new ShareForm("", "", false)) : void 0));
        case 58:
            return noCmd(updateShareForm((form_6) => (new ShareForm(txt_22, "", form_6.IsSending)), cm));
        case 59: {
            const model_109 = updateShareForm((form_7) => (new ShareForm(form_7.UserId, form_7.Error, true)), cm);
            return apiCmd(api.sharePackage, {
                PackageId: pkgId,
                UserId: value_4(cm.ShareForm).UserId,
            }, (Item_7) => (new Msg(54, [Item_7])), (Item_8) => (new Msg(0, [Item_8])), model_109);
        }
        case 60:
            return apiCmd(api.removePackageShare, {
                PackageId: pkgId_1,
                UserId: userId,
            }, (rsp_1) => taggedMsg((Item_9) => (new Msg(55, [Item_9])), userId, rsp_1), (Item_10) => (new Msg(0, [Item_10])), cm);
        case 61:
            return noCmd(updateShareForm((form_8) => (new ShareForm(form_8.UserId, txt_23, false)), cm));
        case 62:
            return noCmd(updateCard((c_8) => (new MainModels_PackageCard(c_8.PackageId, c_8.Producer, c_8.Name, c_8.TransferToken, cons(res_11, c_8.SharedWith), c_8.Slips)), new Model(cm.Packages, cm.Errors, cm.CardIsLoading, cm.Card, cm.AquiringForm, cm.DeleteForm, void 0)));
        case 63:
            return noCmd(updateCard((c_9) => (new MainModels_PackageCard(c_9.PackageId, c_9.Producer, c_9.Name, c_9.TransferToken, filter((r) => (r.Id !== userId_1), c_9.SharedWith), c_9.Slips)), cm));
        case 64:
            return noCmd(editing(addError(txt_24, cm)));
        case 65:
            return noCmd(editing(addError(ex.message, cm)));
        case 66:
            return noCmd(editing(addError(txt_26, cm)));
        default:
            return noCmd(cm);
    }
}

export function view(dispatch, user, settings, model) {
    let children_12, children_10, children_14, children_46, children_24, children_22, props_16, props_18, children_44;
    const children_48 = [(children_12 = [react.createElement("div", {
        className: "level-left",
    }), (children_10 = toList(delay(() => {
        let children_4;
        return append((model.AquiringForm == null) ? singleton_1((children_4 = [react.createElement("button", {
            className: "button is-dark",
            onClick: (_arg) => {
                dispatch(new Msg(40, []));
            },
        }, "Acquire Package")], react.createElement("p", {
            className: "level-item",
        }, ...children_4))) : empty_2(), delay(() => {
            let children_8;
            return singleton_1((children_8 = [react.createElement("button", {
                className: "button is-dark",
                onClick: (_arg_1) => {
                    dispatch(new Msg(1, []));
                },
            }, "Create New Package")], react.createElement("p", {
                className: "level-item",
            }, ...children_8)));
        }));
    })), react.createElement("div", {
        className: "level-right",
    }, ...children_10))], react.createElement("nav", {
        className: "level",
    }, ...children_12)), errors(dispatch, (Item) => (new Msg(2, [Item])), model.Errors), (children_14 = toList(delay(() => {
        const matchValue = model.AquiringForm;
        if (matchValue == null) {
            return empty_2();
        }
        else {
            return singleton_1(aquiringForm(dispatch, matchValue));
        }
    })), react.createElement("div", {}, ...children_14)), (children_46 = [(children_24 = [(children_22 = [(props_16 = [["style", {
        width: "30px",
    }]], react.createElement("th", keyValueList(props_16, 1), "")), (props_18 = [["style", {
        width: "30px",
    }]], react.createElement("th", keyValueList(props_18, 1), "Id")), react.createElement("th", {}, "Name")], react.createElement("tr", {}, ...children_22))], react.createElement("thead", {}, ...children_24)), (children_44 = toList(delay(() => collect((package$) => {
        let children_36, children_28, props_26, children_26, children_30, children_34;
        let hasCard;
        const matchValue_1 = model.Card;
        let matchResult, card_2;
        if (matchValue_1 != null) {
            if (matchValue_1.PackageId === package$.PackageId) {
                matchResult = 0;
                card_2 = matchValue_1;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                hasCard = true;
                break;
            }
            default:
                hasCard = false;
        }
        let isLoading;
        const matchValue_2 = model.CardIsLoading;
        let matchResult_1, id_1;
        if (matchValue_2 != null) {
            if (matchValue_2 === package$.PackageId) {
                matchResult_1 = 0;
                id_1 = matchValue_2;
            }
            else {
                matchResult_1 = 1;
            }
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                isLoading = true;
                break;
            }
            default:
                isLoading = false;
        }
        return append(singleton_1((children_36 = [(children_28 = [(props_26 = [Helpers_classList([["button", true], ["is-small", true], ["is-loading", isLoading]]), new DOMAttr(40, [(_arg_2) => {
            dispatch(new Msg(4, [package$.PackageId]));
        }])], (children_26 = [hasCard ? "-" : "+"], react.createElement("button", keyValueList(props_26, 1), ...children_26)))], react.createElement("th", {}, ...children_28)), (children_30 = [int32ToString(package$.PackageId)], react.createElement("td", {}, ...children_30)), (children_34 = toList(delay(() => append(singleton_1(package$.Name), delay(() => ((package$.Producer !== user.Sub) ? singleton_1(react.createElement("span", {
            className: "tag is-info",
        }, "shared with me")) : empty_2()))))), react.createElement("td", {}, ...children_34))], react.createElement("tr", {}, ...children_36))), delay(() => {
            let children_42, children_40;
            return hasCard ? singleton_1((children_42 = [react.createElement("th", {}), (children_40 = [card(dispatch, user, settings, value_4(model.Card), model.DeleteForm, model.ShareForm, isLoading)], react.createElement("td", {
                colSpan: 2,
            }, ...children_40))], react.createElement("tr", {}, ...children_42))) : empty_2();
        }));
    }, reverse(sortBy((q) => q.PackageId, model.Packages, {
        Compare: comparePrimitives,
    }))))), react.createElement("tbody", {}, ...children_44))], react.createElement("table", {
        className: "table is-fullwidth is-hoverable",
    }, ...children_46))];
    return react.createElement("div", {}, ...children_48);
}

export function aquiringForm(dispatch, form) {
    let children, props, value, children_2, children_6, props_8, children_10, props_12;
    const props_16 = [new HTMLAttr(65, ["field has-addons"]), ["style", {
        paddingBottom: "5px",
    }]];
    const children_12 = [(children = [(props = [new HTMLAttr(65, ["input"]), new HTMLAttr(79, [form.IsSending]), new HTMLAttr(159, ["number"]), new HTMLAttr(128, ["Package Id"]), new HTMLAttr(115, [8]), (value = ((form.PackageId > 0) ? int32ToString(form.PackageId) : ""), ["ref", (e) => {
        Internal_updateInputValue(value, e);
    }]), new DOMAttr(9, [(ev) => {
        dispatch(new Msg(41, [ev.target.value]));
    }])], react.createElement("input", keyValueList(props, 1)))], react.createElement("p", {
        className: "control",
    }, ...children)), (children_2 = [react.createElement("input", {
        className: "input",
        disabled: form.IsSending,
        type: "text",
        placeholder: "Transfer Token",
        maxLength: 128,
        ref: (e_1) => {
            Internal_updateInputValue(form.TransferToken, e_1);
        },
        onChange: (ev_1) => {
            dispatch(new Msg(42, [ev_1.target.value]));
        },
    })], react.createElement("p", {
        className: "control is-expanded",
    }, ...children_2)), (children_6 = [(props_8 = [Helpers_classList([["button", true], ["has-text-danger", true], ["has-text-weight-semibold", true], ["is-loading", form.IsSending]]), new HTMLAttr(79, [(form.PackageId <= 0) ? true : isNullOrWhiteSpace(form.TransferToken)]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(43, []));
    }])], react.createElement("button", keyValueList(props_8, 1), "Acquire"))], react.createElement("p", {
        className: "control",
    }, ...children_6)), (children_10 = [(props_12 = [Helpers_classList([["button", true]]), new DOMAttr(40, [(_arg_1) => {
        dispatch(new Msg(44, []));
    }])], react.createElement("button", keyValueList(props_12, 1), "Cancel"))], react.createElement("p", {
        className: "control",
    }, ...children_10))];
    return react.createElement("div", keyValueList(props_16, 1), ...children_12);
}

export function card(dispatch, user, settings, card_1, deleteForm, shareForm, isLoading) {
    const isOwned = user.Sub === card_1.Producer;
    const children_114 = toList(delay(() => {
        let children_74, children_12, children_40, children_72;
        return append(isOwned ? append(singleton_1((children_74 = [(children_12 = toList(delay(() => {
            let children_2;
            return append(singleton_1((children_2 = ["Package Name", react.createElement("span", {
                className: "has-text-danger",
            }, "*")], react.createElement("label", {
                className: "label",
            }, ...children_2))), delay(() => {
                let children_4, props_4;
                const error = validateName(card_1.Name);
                return append(singleton_1((children_4 = [(props_4 = [Helpers_classList([["input", true], ["is-danger", error !== ""]]), new HTMLAttr(79, [isLoading]), new HTMLAttr(159, ["text"]), new HTMLAttr(128, ["PKG #3"]), new HTMLAttr(115, [128]), ["ref", (e) => {
                    Internal_updateInputValue(card_1.Name, e);
                }], new DOMAttr(9, [(ev) => {
                    dispatch(new Msg(7, [ev.target.value]));
                }])], react.createElement("input", keyValueList(props_4, 1)))], react.createElement("div", {
                    className: "control",
                }, ...children_4))), delay(() => append(singleton_1(react.createElement("p", {
                    className: "help is-danger",
                }, error)), delay(() => append(singleton_1(react.createElement("label", {
                    className: "label",
                }, "Transfer token")), delay(() => {
                    let children_10;
                    return singleton_1((children_10 = [react.createElement("input", {
                        className: "input",
                        disabled: isLoading,
                        type: "text",
                        maxLength: 128,
                        ref: (e_1) => {
                            Internal_updateInputValue(card_1.TransferToken, e_1);
                        },
                        onChange: (ev_1) => {
                            dispatch(new Msg(8, [ev_1.target.value]));
                        },
                    })], react.createElement("div", {
                        className: "control",
                    }, ...children_10)));
                }))))));
            }));
        })), react.createElement("div", {
            className: "column",
        }, ...children_12)), (children_40 = toList(delay(() => append(singleton_1(react.createElement("label", {
            className: "label",
        }, "Shared With")), delay(() => {
            let children_22, children_20;
            return append(singleton_1((children_22 = [(children_20 = toList(delay(() => map((record) => {
                let props_20, children_16;
                const children_18 = [record.Name, (props_20 = [new HTMLAttr(65, ["button is-small is-text has-text-danger"]), ["style", {
                    display: "inline",
                }], new HTMLAttr(158, ["Remove Sharing"]), new DOMAttr(40, [(_arg) => {
                    dispatch(new Msg(53, [card_1.PackageId, record.Id]));
                }])], (children_16 = [Fa_span(ofArray([new Fa_IconOption(0, [new Fa_ISize(1, [])]), new Fa_IconOption(11, ["fas fa-times"])]), [])], react.createElement("a", keyValueList(props_20, 1), ...children_16)))];
                return react.createElement("li", {}, ...children_18);
            }, card_1.SharedWith))), react.createElement("ul", {}, ...children_20))], react.createElement("div", {
                className: "content",
            }, ...children_22))), delay(() => {
                let props_44, children_38, children_28, children_32, props_36, children_36;
                const matchValue = shareForm;
                if (matchValue != null) {
                    const form = matchValue;
                    return singleton_1((props_44 = [new HTMLAttr(65, ["field has-addons"]), ["style", {
                        paddingBottom: "5px",
                    }]], (children_38 = [(children_28 = [react.createElement("input", {
                        className: "input is-small",
                        disabled: form.IsSending,
                        type: "text",
                        placeholder: "User Id",
                        maxLength: 128,
                        ref: (e_2) => {
                            Internal_updateInputValue(form.UserId, e_2);
                        },
                        onChange: (ev_2) => {
                            dispatch(new Msg(51, [ev_2.target.value]));
                        },
                    }), react.createElement("span", {
                        className: "help is-danger",
                    }, form.Error)], react.createElement("p", {
                        className: "control is-expanded",
                    }, ...children_28)), (children_32 = [(props_36 = [Helpers_classList([["button", true], ["is-small", true], ["is-loading", form.IsSending]]), new HTMLAttr(79, [form.UserId === ""]), new DOMAttr(40, [(_arg_2) => {
                        dispatch(new Msg(52, [card_1.PackageId]));
                    }])], react.createElement("button", keyValueList(props_36, 1), "Share"))], react.createElement("p", {
                        className: "control",
                    }, ...children_32)), (children_36 = [react.createElement("button", {
                        className: "button is-small",
                        onClick: (_arg_3) => {
                            dispatch(new Msg(50, []));
                        },
                    }, "Cancel")], react.createElement("p", {
                        className: "control",
                    }, ...children_36))], react.createElement("div", keyValueList(props_44, 1), ...children_38))));
                }
                else {
                    return singleton_1(react.createElement("button", {
                        className: "button is-small",
                        onClick: (_arg_1) => {
                            dispatch(new Msg(50, []));
                        },
                    }, "Share"));
                }
            }));
        })))), react.createElement("div", {
            className: "column",
        }, ...children_40)), (children_72 = toList(delay(() => {
            let children_70, props_58, children_50, children_48, children_46, children_42, props_66, children_58, children_56, children_52, children_62, props_74, children_66;
            if (deleteForm == null) {
                return singleton_1((children_70 = [(props_58 = [new HTMLAttr(65, ["file"]), ["style", {
                    marginLeft: "5px",
                }]], (children_50 = [(children_48 = [react.createElement("input", {
                    className: "file-input",
                    type: "file",
                    name: "picture",
                    onChange: (ev_3) => {
                        fileOnChangeAsText(void 0, (arg) => {
                            dispatch(new Msg(9, [arg]));
                        }, ev_3);
                    },
                }), (children_46 = [(children_42 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-upload"])), [])], react.createElement("span", {
                    className: "file-icon",
                }, ...children_42)), react.createElement("span", {
                    className: "file-label",
                }, "Import")], react.createElement("span", {
                    className: "file-cta",
                }, ...children_46))], react.createElement("label", {
                    className: "file-label",
                }, ...children_48))], react.createElement("div", keyValueList(props_58, 1), ...children_50))), (props_66 = [new HTMLAttr(65, ["control"]), ["style", {
                    marginLeft: "5px",
                }]], (children_58 = [(children_56 = [(children_52 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-download"])), [])], react.createElement("span", {
                    className: "icon",
                }, ...children_52)), react.createElement("span", {}, "Export")], react.createElement("button", {
                    className: "button",
                    onClick: (_arg_4) => {
                        dispatch(new Msg(10, []));
                    },
                }, ...children_56))], react.createElement("div", keyValueList(props_66, 1), ...children_58))), (children_62 = toList(delay(() => {
                    const hasErrors = !isEmpty(validate(card_1));
                    return singleton_1(react.createElement("button", {
                        className: "button is-dark ",
                        disabled: hasErrors,
                        onClick: (_arg_5) => {
                            dispatch(new Msg(12, []));
                        },
                    }, "Submit"));
                })), react.createElement("div", {
                    className: "control",
                }, ...children_62)), (props_74 = [new HTMLAttr(65, ["control"]), ["style", {
                    marginLeft: "5px",
                }]], (children_66 = [react.createElement("button", {
                    className: "button",
                    onClick: (_arg_6) => {
                        dispatch(new Msg(11, []));
                    },
                }, "Cancel")], react.createElement("div", keyValueList(props_74, 1), ...children_66))), react.createElement("button", {
                    className: "button is-danger",
                    onClick: (_arg_7) => {
                        dispatch(new Msg(46, []));
                    },
                }, "Delete Package")], react.createElement("div", {
                    className: "field is-grouped",
                }, ...children_70)));
            }
            else {
                const form_1 = deleteForm;
                return singleton_1(deleteForm_1(dispatch, "Type name of the Package to confirm", card_1.Name, form_1.ConfirmText, form_1.IsSending, form_1.FormError, new Msg(46, []), (Item) => (new Msg(47, [Item])), new Msg(48, [card_1.PackageId])));
            }
        })), react.createElement("div", {
            className: "column",
        }, ...children_72))], react.createElement("div", {
            className: "columns",
        }, ...children_74))), delay(() => {
            let children_92, children_78, children_82, children_86, children_90;
            return singleton_1((children_92 = [(children_78 = [react.createElement("button", {
                className: "button ",
                disabled: isLoading,
                onClick: (_arg_8) => {
                    dispatch(new Msg(14, [1]));
                },
            }, "Append Question")], react.createElement("div", {
                className: "control",
            }, ...children_78)), (children_82 = [react.createElement("button", {
                className: "button ",
                disabled: isLoading,
                onClick: (_arg_9) => {
                    dispatch(new Msg(14, [2]));
                },
            }, "Append Doublet")], react.createElement("div", {
                className: "control",
            }, ...children_82)), (children_86 = [react.createElement("button", {
                className: "button ",
                disabled: isLoading,
                onClick: (_arg_10) => {
                    dispatch(new Msg(14, [3]));
                },
            }, "Append Blitz")], react.createElement("div", {
                className: "control",
            }, ...children_86)), (children_90 = [react.createElement("button", {
                className: "button ",
                disabled: isLoading,
                onClick: (_arg_11) => {
                    dispatch(new Msg(15, []));
                },
            }, "Append Multiple Slip")], react.createElement("div", {
                className: "control",
            }, ...children_90))], react.createElement("div", {
                className: "field is-grouped",
            }, ...children_92)));
        })) : empty_2(), delay(() => {
            let children_112, children_108, children_106, props_102, props_110, props_112, children_110;
            return singleton_1((children_112 = [(children_108 = [(children_106 = [(props_102 = [["style", {
                width: "90px",
            }]], react.createElement("th", keyValueList(props_102, 1), "#")), react.createElement("th", {}, "Question"), react.createElement("th", {}, "Answer"), react.createElement("th", {}, "Comment"), (props_110 = [["style", {
                width: "90px",
            }]], react.createElement("th", keyValueList(props_110, 1), "Points")), (props_112 = [["style", {
                width: "30px",
            }]], react.createElement("th", keyValueList(props_112, 1), "Del"))], react.createElement("tr", {}, ...children_106))], react.createElement("thead", {}, ...children_108)), (children_110 = toList(delay(() => collect((matchValue_1) => {
                const slipIdx = matchValue_1[0] | 0;
                const matchValue_2 = matchValue_1[1];
                return (matchValue_2.tag === 1) ? append(singleton_1(multipleSlipRowHeader(dispatch, isOwned, isLoading, card_1.PackageId, slipIdx, matchValue_2.fields[0])), delay(() => collect((matchValue_3) => singleton_1(singleSlipRow(dispatch, settings, isOwned, isLoading, card_1.PackageId, slipIdx, matchValue_3[0], matchValue_3[1])), reverse(indexed(matchValue_2.fields[1]))))) : singleton_1(singleSlipRow(dispatch, settings, isOwned, isLoading, card_1.PackageId, slipIdx, void 0, matchValue_2.fields[0]));
            }, reverse(indexed(card_1.Slips))))), react.createElement("tbody", {}, ...children_110))], react.createElement("table", {
                className: "table is-fullwidth",
            }, ...children_112)));
        }));
    }));
    return react.createElement("div", {}, ...children_114);
}

export function idxCell(tourIdx, qwIdx) {
    const children = toList(delay(() => {
        let copyOfStruct;
        return append(singleton_1((copyOfStruct = (tourIdx + 1), int32ToString(copyOfStruct))), delay(() => {
            let arg;
            const matchValue = qwIdx;
            if (matchValue == null) {
                return empty_2();
            }
            else {
                return singleton_1((arg = ((matchValue + 1) | 0), toText(printf(".%i"))(arg)));
            }
        }));
    }));
    return react.createElement("td", {}, ...children);
}

export function idxCellInSlip(dispatch, qwKey, slip, isLoading) {
    let children, children_2;
    const children_4 = [(children = [react.createElement("input", {
        className: "input",
        ref: (e) => {
            Internal_updateInputValue(slip.Caption, e);
        },
        maxLength: 4,
        readOnly: isLoading,
        onChange: (ev) => {
            dispatch(new Msg(29, [qwKey, ev.target.value]));
        },
    })], react.createElement("div", {
        className: "control",
    }, ...children)), (children_2 = [react.createElement("input", {
        type: "checkbox",
        checked: slip.EndOfTour,
        readOnly: isLoading,
        onChange: (ev_1) => {
            dispatch(new Msg(28, [qwKey, ev_1.target.checked]));
        },
    }), " EOT"], react.createElement("label", {
        className: "checkbox",
        title: "End Of Tour",
    }, ...children_2))];
    return react.createElement("td", {}, ...children_4);
}

export function delTourCell(dispatch, tourIdx) {
    let children;
    const children_2 = [(children = [Fa_i(singleton(new Fa_IconOption(11, ["far fa-trash-alt"])), [])], react.createElement("button", {
        className: "button is-small",
        onClick: (_arg) => {
            dispatch(new Msg(17, [tourIdx]));
        },
    }, ...children))];
    return react.createElement("td", {}, ...children_2);
}

export function delQwCell(dispatch, qwKey) {
    let children;
    const children_2 = [(children = [Fa_i(singleton(new Fa_IconOption(11, ["far fa-trash-alt"])), [])], react.createElement("button", {
        className: "button is-small",
        onClick: (_arg) => {
            dispatch(new Msg(18, [qwKey]));
        },
    }, ...children))];
    return react.createElement("td", {}, ...children_2);
}

export function qwCell(dispatch, settings, key, txt, media, isLoading) {
    const children_2 = toList(delay(() => append(singleton_1(react.createElement("textarea", {
        className: "textarea",
        ref: (e) => {
            Internal_updateInputValue(txt, e);
        },
        maxLength: 1024,
        onChange: (ev) => {
            dispatch(new Msg(20, [PkgQwKey__get_Key(key), ev.target.value]));
        },
    })), delay(() => append(singleton_1(react.createElement("br", {})), delay(() => mediaArea(key, isLoading, (v) => {
        dispatch(new Msg(33, [PkgQwKey__get_Key(key), v]));
    }, (v_1) => {
        dispatch(new Msg(34, [PkgQwKey__get_Key(key), v_1]));
    }, (arg) => {
        dispatch(new Msg(30, [arg]));
    }, () => {
        dispatch(new Msg(31, [PkgQwKey__get_Key(key)]));
    }, settings.MediaHost, media, "Clear")))))));
    return react.createElement("td", {}, ...children_2);
}

export function qwInput(dispatch, placeholder, txt, key, partIdx) {
    const props_2 = [new HTMLAttr(65, ["control"]), ["style", {
        marginBottom: "3px",
    }]];
    const children = [react.createElement("input", {
        className: "input",
        type: "text",
        placeholder: placeholder,
        ref: (e) => {
            Internal_updateInputValue(txt, e);
        },
        maxLength: 1024,
        onChange: (ev) => {
            dispatch(new Msg(21, [key, partIdx, ev.target.value]));
        },
    })];
    return react.createElement("div", keyValueList(props_2, 1), ...children);
}

export function awCell(dispatch, key, answer, isLoading) {
    const children_30 = toList(delay(() => {
        let children_4, props, props_2;
        return append(singleton_1((children_4 = [(props = [Helpers_classList([["button", true], ["is-small", true], ["has-text-weight-bold", SlipAnswer__IsOpen(answer)]]), new DOMAttr(40, [(_arg) => {
            dispatch(new Msg(57, [PkgQwKey__get_Key(key)]));
        }])], react.createElement("button", keyValueList(props, 1), "open answer")), (props_2 = [Helpers_classList([["button", true], ["is-small", true], ["has-text-weight-bold", !SlipAnswer__IsOpen(answer)]]), new DOMAttr(40, [(_arg_1) => {
            dispatch(new Msg(56, [PkgQwKey__get_Key(key)]));
        }])], react.createElement("button", keyValueList(props_2, 1), "multiple choices"))], react.createElement("div", {
            className: "buttons has-addons",
        }, ...children_4))), delay(() => {
            let children_26;
            const matchValue = answer;
            return (matchValue.tag === 1) ? append(singleton_1((children_26 = toList(delay(() => collect((matchValue_1) => {
                let children_24, children_22, children_8, children_12, props_12, children_16, props_16, children_20, children_18;
                const idx = matchValue_1[0] | 0;
                const ch = matchValue_1[1];
                return singleton_1((children_24 = [(children_22 = [(children_8 = [react.createElement("input", {
                    className: "input is-small",
                    type: "text",
                    ref: (e_1) => {
                        Internal_updateInputValue(ch.Text, e_1);
                    },
                    onChange: (ev_1) => {
                        dispatch(new Msg(61, [PkgQwKey__get_Key(key), idx, ev_1.target.value]));
                    },
                })], react.createElement("div", {
                    className: "control",
                }, ...children_8)), (children_12 = [(props_12 = [Helpers_classList([["button", true], ["is-small", true], ["is-primary", ch.IsCorrect]]), new DOMAttr(40, [(_arg_2) => {
                    dispatch(new Msg(58, [PkgQwKey__get_Key(key), idx, true]));
                }])], react.createElement("a", keyValueList(props_12, 1), "correct"))], react.createElement("div", {
                    className: "control",
                }, ...children_12)), (children_16 = [(props_16 = [Helpers_classList([["button", true], ["is-small", true], ["is-danger", !ch.IsCorrect]]), new DOMAttr(40, [(_arg_3) => {
                    dispatch(new Msg(58, [PkgQwKey__get_Key(key), idx, false]));
                }])], react.createElement("a", keyValueList(props_16, 1), "wrong"))], react.createElement("div", {
                    className: "control",
                }, ...children_16)), (children_20 = [(children_18 = [Fa_i(singleton(new Fa_IconOption(11, ["fas fa-trash"])), [])], react.createElement("a", {
                    className: "button is-small",
                    onClick: (_arg_4) => {
                        dispatch(new Msg(59, [PkgQwKey__get_Key(key), idx]));
                    },
                }, ...children_18))], react.createElement("div", {
                    className: "control",
                }, ...children_20))], react.createElement("div", {
                    className: "field has-addons",
                }, ...children_22))], react.createElement("li", {}, ...children_24)));
            }, mapIndexed((idx_1, ch_1) => [idx_1, ch_1], matchValue.fields[0])))), react.createElement("ul", {}, ...children_26))), delay(() => singleton_1(react.createElement("button", {
                className: "button is-small",
                onClick: (_arg_5) => {
                    dispatch(new Msg(60, [PkgQwKey__get_Key(key)]));
                },
            }, "append choice")))) : singleton_1(react.createElement("textarea", {
                className: "textarea",
                rows: 2,
                ref: (e) => {
                    Internal_updateInputValue(matchValue.fields[0], e);
                },
                maxLength: 1024,
                onChange: (ev) => {
                    dispatch(new Msg(22, [PkgQwKey__get_Key(key), ev.target.value]));
                },
            }));
        }));
    }));
    return react.createElement("td", {}, ...children_30);
}

export function cmntCell(dispatch, settings, key, txt, media, isLoading) {
    const children_2 = toList(delay(() => append(singleton_1(react.createElement("textarea", {
        className: "textarea",
        ref: (e) => {
            Internal_updateInputValue(txt, e);
        },
        maxLength: 1024,
        onChange: (ev) => {
            dispatch(new Msg(23, [PkgQwKey__get_Key(key), ev.target.value]));
        },
    })), delay(() => append(singleton_1(react.createElement("br", {})), delay(() => mediaArea(key, isLoading, (v) => {
        dispatch(new Msg(38, [PkgQwKey__get_Key(key), v]));
    }, (v_1) => {
        dispatch(new Msg(39, [PkgQwKey__get_Key(key), v_1]));
    }, (arg) => {
        dispatch(new Msg(35, [arg]));
    }, () => {
        dispatch(new Msg(36, [PkgQwKey__get_Key(key)]));
    }, settings.MediaHost, media, "Clear")))))));
    return react.createElement("td", {}, ...children_2);
}

export function singleSlipRow(dispatch, settings, isOwned, isLoading, pkgId, tourIdx, qwIdx, slip) {
    const packageKey = new PkgQwKey(pkgId, tourIdx, defaultArg(qwIdx, 0));
    const children_12 = toList(delay(() => append((qwIdx == null) ? singleton_1(idxCellInSlip(dispatch, PkgQwKey__get_Key(packageKey), slip, isLoading)) : singleton_1(idxCell(tourIdx, qwIdx)), delay(() => {
        let matchValue_1, children;
        return append((matchValue_1 = slip.Question, (matchValue_1.tag === 1) ? singleton_1((children = toList(delay(() => append(collect((matchValue_2) => {
            let arg;
            const idx = matchValue_2[0] | 0;
            return singleton_1(qwInput(dispatch, (arg = ((idx + 1) | 0), toText(printf("Question %i"))(arg)), matchValue_2[1], PkgQwKey__get_Key(packageKey), idx));
        }, indexed(matchValue_1.fields[0])), delay(() => append(singleton_1(react.createElement("br", {})), delay(() => mediaArea(packageKey, isLoading, (v) => {
            dispatch(new Msg(33, [PkgQwKey__get_Key(packageKey), v]));
        }, (v_1) => {
            dispatch(new Msg(34, [PkgQwKey__get_Key(packageKey), v_1]));
        }, (arg_1) => {
            dispatch(new Msg(30, [arg_1]));
        }, () => {
            dispatch(new Msg(31, [PkgQwKey__get_Key(packageKey)]));
        }, settings.MediaHost, slip.QuestionMedia, "Clear"))))))), react.createElement("td", {}, ...children))) : singleton_1(qwCell(dispatch, settings, packageKey, matchValue_1.fields[0], slip.QuestionMedia, isLoading))), delay(() => append(singleton_1(awCell(dispatch, packageKey, slip.Answer, isLoading)), delay(() => append(singleton_1(cmntCell(dispatch, settings, packageKey, slip.Comment, slip.AnswerMedia, isLoading)), delay(() => {
            let children_10, children_2, props_4, value_1, children_4, props_8, value_2, matchValue_3, children_6, children_8, props_16, value_3, matchValue_4;
            return append(singleton_1((children_10 = [(children_2 = [(props_4 = [new HTMLAttr(65, ["input"]), new HTMLAttr(159, ["number"]), (value_1 = toString(slip.Points), ["ref", (e) => {
                Internal_updateInputValue(value_1, e);
            }]), new HTMLAttr(115, [4]), new HTMLAttr(132, [isLoading]), new DOMAttr(9, [(ev) => {
                dispatch(new Msg(24, [PkgQwKey__get_Key(packageKey), ev.target.value]));
            }])], react.createElement("input", keyValueList(props_4, 1)))], react.createElement("div", {
                className: "control",
            }, ...children_2)), "Jeopardy", (children_4 = [(props_8 = [new HTMLAttr(65, ["input"]), new HTMLAttr(159, ["number"]), (value_2 = ((matchValue_3 = slip.JeopardyPoints, (matchValue_3 == null) ? "" : toString(matchValue_3))), ["ref", (e_1) => {
                Internal_updateInputValue(value_2, e_1);
            }]), new HTMLAttr(115, [4]), new HTMLAttr(132, [isLoading]), new DOMAttr(9, [(ev_1) => {
                dispatch(new Msg(25, [PkgQwKey__get_Key(packageKey), ev_1.target.value]));
            }])], react.createElement("input", keyValueList(props_8, 1)))], react.createElement("div", {
                className: "control",
            }, ...children_4)), (children_6 = [react.createElement("input", {
                type: "checkbox",
                checked: slip.WithChoice,
                readOnly: isLoading,
                onChange: (ev_2) => {
                    dispatch(new Msg(26, [PkgQwKey__get_Key(packageKey), ev_2.target.checked]));
                },
            }), " with choice"], react.createElement("label", {
                className: "checkbox",
            }, ...children_6)), "Seconds", (children_8 = [(props_16 = [new HTMLAttr(65, ["input"]), new HTMLAttr(159, ["number"]), (value_3 = ((matchValue_4 = slip.Seconds, (matchValue_4 == null) ? "" : int32ToString(matchValue_4))), ["ref", (e_2) => {
                Internal_updateInputValue(value_3, e_2);
            }]), new HTMLAttr(115, [3]), new HTMLAttr(132, [isLoading]), new DOMAttr(9, [(ev_3) => {
                dispatch(new Msg(27, [PkgQwKey__get_Key(packageKey), ev_3.target.value]));
            }])], react.createElement("input", keyValueList(props_16, 1)))], react.createElement("div", {
                className: "control",
            }, ...children_8))], react.createElement("td", {}, ...children_10))), delay(() => {
                if (isOwned) {
                    const matchValue_5 = qwIdx;
                    return (matchValue_5 == null) ? singleton_1(delTourCell(dispatch, tourIdx)) : singleton_1(delQwCell(dispatch, new QwKey(tourIdx, matchValue_5)));
                }
                else {
                    return empty_2();
                }
            }));
        }))))));
    }))));
    return react.createElement("tr", {}, ...children_12);
}

export function multipleSlipRowHeader(dispatch, isOwned, isLoading, pkgId, tourIdx, name) {
    let children_8, props_8, children_6, children, children_4, props_4;
    const children_12 = [idxCell(tourIdx, void 0), (children_8 = [(props_8 = [new HTMLAttr(65, ["field has-addons"]), ["style", {
        paddingBottom: "5px",
    }]], (children_6 = [(children = [react.createElement("input", {
        className: "input",
        disabled: isLoading,
        type: "text",
        placeholder: "Tour Name",
        maxLength: 128,
        ref: (e) => {
            Internal_updateInputValue(name, e);
        },
        onChange: (ev) => {
            dispatch(new Msg(19, [tourIdx, ev.target.value]));
        },
    })], react.createElement("p", {
        className: "control is-expanded",
    }, ...children)), (children_4 = [(props_4 = [Helpers_classList([["button", true], ["has-text-weight-semibold", true], ["is-loading", isLoading]]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(16, [tourIdx]));
    }])], react.createElement("button", keyValueList(props_4, 1), "Append Question To Slip"))], react.createElement("p", {
        className: "control",
    }, ...children_4))], react.createElement("div", keyValueList(props_8, 1), ...children_6)))], react.createElement("td", {
        colSpan: 3,
    }, ...children_8)), react.createElement("td", {}), delTourCell(dispatch, tourIdx)];
    return react.createElement("tr", {}, ...children_12);
}

